<div class="cd-back-text" (click)="onBack()">
  <div>
    <cds-icon [config]="backIconConfig" [icon]="backIcon"> </cds-icon>
  </div>
  <div class="cd-ml-10">
    <span class="cds-body2-demibold">{{ title }}</span>
  </div>
</div>
